import { tns } from 'tiny-slider/src/tiny-slider';

class BuilderTool {
	constructor(el) {
		this.el = el;
		this.tabs = this.el.querySelectorAll('.block-builder-tool__tab');
		this.tabContentContainer = this.el.querySelectorAll(
			'.block-builder-tool__tab-content-container'
		);
		this.tabContent = this.el.querySelectorAll('.block-builder-tool__tab-content');
		this.tabContentTitle = this.el.querySelectorAll('.block-builder-tool__tab-content-title');
		this.tabContentTitleMobile = this.el.querySelectorAll(
			'.block-builder-tool__tab-content-title--mobile'
		);
		this.tabContentWrapper = this.el.querySelectorAll(
			'.block-builder-tool__tab-content-wrapper'
		);
		this.tabContinueButtons = this.el.querySelectorAll(
			'.block-builder-tool__tab-continue-button'
		);

		this.radioSwitch = this.el.querySelectorAll('.block-builder-tool__radio-switch');
		this.accordionSelectOptions = this.el.querySelectorAll(
			'.block-builder-tool__accordion-select-option'
		);

		this.form = this.el.querySelector('form');

		this.handleTabClick();
		this.handleTabContinueButtonClick();
		this.handleAccordionClick();
		this.initiateSliders();

		this.handleRadioSliderOptionClick();
		this.handleAccordionSelectClick();

		this.handleFormChange();
		this.handleFormSubmit();

		this.setInitialDisabledOptionStates();

		this.formData = {};

		window.addEventListener('resize', () => {
			this.handleTabClick();
			this.handleTabContinueButtonClick();
			this.handleAccordionClick();
			this.handleRadioSliderOptionClick();
		});

		this.queryParams = '';
	}

	initiateSliders = () => {
		const sliderWrappers = this.el.querySelectorAll('.block-builder-tool__slider-wrapper');
		sliderWrappers.forEach((sliderWrapper) => {
			const slider = sliderWrapper.querySelector('.block-builder-tool__slider');
			const prevButton = sliderWrapper.querySelector('.tns-prev');
			const nextButton = sliderWrapper.querySelector('.tns-next');
			tns({
				container: slider,
				items: 1,
				autoplay: true,
				autoplayButtonOutput: false,
				mouseDrag: true,
				preventScrollOnTouch: 'auto',
				swipeAngle: false,
				speed: 400,
				controls: true,
				prevButton: prevButton,
				nextButton: nextButton
			});
		});
	};

	handleTabClick = () => {
		// if (window.innerWidth >= 1023) {
			this.tabs.forEach((tab) => {
				tab.addEventListener('click', () => {
					this.scrollToTop();

					this.tabContentContainer.forEach((tabContent) => {
						if (tabContent.dataset.index === tab.dataset.index) {
							tabContent.classList.add('active');
						} else {
							tabContent.classList.remove('active');
						}
					});
					this.tabs.forEach((t) => {
						if (t.dataset.index !== tab.dataset.index) {
							t.classList.remove('active');
						} else {
							t.classList.add('active');
						}
					});

					this.accordionSelectOptions.forEach((option) => {
						option.classList.remove('active');
					});
				});
			});
		// }
	};

	handleTabContinueButtonClick = () => {
		this.tabContinueButtons.forEach((button) => {
			button.addEventListener('click', () => {
				this.scrollToTop();
				const tabContentTargetIndex = (parseInt(button.dataset.index, 10) + 1).toString();
				this.tabContentContainer.forEach((tabContent) => {
					if (tabContent.dataset.index === tabContentTargetIndex) {
						tabContent.classList.add('active');
					} else {
						tabContent.classList.remove('active');
					}
				});

				this.tabs.forEach((t) => {
					if (t.dataset.index !== tabContentTargetIndex) {
						t.classList.remove('active');
					} else {
						t.classList.add('active');
					}
				});
			});
		});
	};

	setInitialDisabledOptionStates = () => {
		const radioInputs = this.el.querySelectorAll('input[type="radio"]');
		const inputs = this.el.querySelectorAll('input');
		window.addEventListener('load', () => {
			radioInputs.forEach((radioInput) => {
				const trimmedRadioValue = radioInput.dataset.disable.replace(/\s/g, '');
				const radioDisabledArray = trimmedRadioValue.split(',');
				if (radioInput.checked === true) {
					inputs.forEach((i) => {
						if (i.dataset.name && radioDisabledArray.includes(i.dataset.name)) {
							i.disabled = true;
						}
					});
				}
			});
		});
	};

	scrollToTop = () => {
		const wrapper = document.querySelector('.block-builder-tool__tab-content-wrapper');
		const elementOffset = wrapper.getBoundingClientRect().top;
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const elementTop = elementOffset + scrollTop - 200;
		window.scrollTo({
			top: elementTop,
			behavior: 'smooth'
		});
		document.querySelector('.block-builder-tool__tabs').style.top = '250px';
	};

	handleRadioSliderOptionClick = () => {
		this.radioSwitch.forEach((r) => {
			const form = r.querySelector('.block-builder-tool__form');
			form.addEventListener('change', () => {
				form.querySelectorAll('input').forEach((input) => {
					if (input.checked === true) {
						input.parentNode.classList.add('active');
						const imageContainers = r.querySelectorAll(
							'.block-builder-tool__radio-image-container'
						);

						imageContainers.forEach((image) => {
							if (
								image.dataset.radioOptionImageIndex ===
								input.dataset.radioOptionIndex
							) {
								image.classList.add('active');
								image.classList.add('test');
							} else {
								image.classList.remove('active');
							}
						});
					} else {
						input.parentNode.classList.remove('active');
					}
				});
			});
		});
	};

	handleAccordionClick = () => {
		if (window.innerWidth < 1024) {
			this.tabContentTitleMobile.forEach((title) => {
				title.addEventListener('click', () => {
					if (title.classList.contains('active')) {
						title.classList.remove('active');
					} else {
						title.classList.add('active');
					}
				});
			});
		}
	};

	handleAccordionSelectClick = () => {
		this.accordionSelectOptions.forEach((option) => {
			const title = option.querySelector(
				'.block-builder-tool__accordion-select-option-title'
			);
			title.addEventListener('click', () => {
				if (option.classList.contains('active')) {
					option.classList.remove('active');
				} else {
					this.accordionSelectOptions.forEach((c) => {
						if (c.dataset.index !== title.dataset.index) {
							c.classList.remove('active');
						} else {
							c.classList.add('active');
						}
					});
				}
			});
		});
	};

	handleFormChange = () => {
		let previousRadioValue = null;
		let previousRadioDisabledValue = [];
		if (this.form) {
			this.form.addEventListener('change', (evt) => {
				this.queryParams = '';
				// console.log(evt);
				// evt.target = evt.target || this.form.querySelectorAll('input[type="radio"]')[0];
				const formSections = this.form.querySelectorAll('.block-builder-tool__form');
				const builderWeightEl = this.el.querySelector('.block-builder-tool__weight-variable');
				const builderPriceEl = this.el.querySelector('.block-builder-tool__price-variable');
				const trimmedInput = evt.target.dataset.disable.replace(/\s/g, '');
				const disabledArray = trimmedInput.split(',');
				let builderPrice = 0;
				let builderWeight = 0;

				formSections.forEach((section) => {
					const inputs = section.querySelectorAll('input');
					this.formData[section.dataset.id] = [];
					inputs.forEach((input) => {
						if (evt.target.type === 'checkbox') {
							if (input.dataset.name && disabledArray.includes(input.dataset.name)) {
								if (evt.target.checked === true) {
									input.disabled = true;
									input.checked = false;
								} else {
									input.disabled = false;
								}
							}
						} else if (evt.target.type === 'radio') {
							const trimmedRadioValue = evt.target.dataset.disable.replace(/\s/g, '');
							const currentRadioDisabledArray = trimmedRadioValue.split(',');
							previousRadioDisabledValue = currentRadioDisabledArray;
							previousRadioValue = evt.target.value;
							if (
								input.dataset.name &&
								currentRadioDisabledArray.includes(input.dataset.name)
							) {
								input.disabled = true;
								input.checked = false;
							} else {
								input.disabled = false;
							}
						}
						if (input.checked === true) {
							builderPrice += parseInt(input.dataset.price, 10);
							builderPriceEl.innerHTML = builderPrice.toLocaleString();

							builderWeight += parseInt(input.dataset.weight, 10);
							builderWeightEl.innerHTML = builderWeight;

							if (input.type === 'checkbox') {
								if (Array.isArray(this.formData[section.dataset.id])) {
									this.formData[section.dataset.id].push([
										input.value,
										input.dataset.price
									]);
								} else {
									this.formData[section.dataset.id] = [
										[input.value, input.dataset.price]
									];
								}
							} else {
								this.formData[section.dataset.id] = [];
								this.formData[section.dataset.id].push(input.value);
								this.formData[section.dataset.id].push(input.dataset.price);
							}
						} else if (input.type === 'hidden') {
							this.formData[section.dataset.id] = input.value;
						}
					});
					this.formData.TotalPrice = builderPrice;
					this.formData.TotalWeight = builderWeight;
				});

				Object.keys(this.formData).forEach((key) => {
					const value = this.formData[key];
					const keyWithoutAmpersand = key.replace(/&/g, '');
					// const key = key.replace(/&/g, '');
					if (Array.isArray(value) && value.length > 0) {
						this.queryParams += `${keyWithoutAmpersand}: ${value.join(' - ')}****`;
					} else {
						this.queryParams += `${keyWithoutAmpersand}: ${value}****`;
					}
				});

				// console.log(this.queryParams);
			});
		}
	};

	handleFormSubmit = () => {
		if (this.form) {
			this.form.addEventListener('submit', (e) => {
				e.preventDefault();
				this.updateSessions();
			});
		}
	};

	updateSessions = () => {
		const formData = this.formData;

		sessionStorage.setItem('formData', JSON.stringify(formData));

		var formDataToSend = new FormData();
		formDataToSend.append('builderToolFormData', JSON.stringify(formData));
		formDataToSend.append('action', window.apiSettings.action);

		fetch(window.apiSettings.ajaxurl, {
			method: 'POST',
			body: formDataToSend
		})
			.then((response) => response.text())
			.then((data) => {
				window.location.href = '/builder-results?builder_info=' + this.queryParams;
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	};
}

export default BuilderTool;
